import createIcon from '../../createIcon';

/**
 * @component @name EditNote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi45MzM1OSA4LjVIMTMuOTMzNlYxMC41SDIuOTMzNTlWOC41Wk0yLjkzMzU5IDYuNUgxMy45MzM2VjQuNUgyLjkzMzU5VjYuNVpNMi45MzM1OSAxNC41SDkuOTMzNTlWMTIuNUgyLjkzMzU5VjE0LjVaTTE3Ljk0MzYgMTEuMzdMMTguNjUzNiAxMC42NkMxOS4wNDM2IDEwLjI3IDE5LjY3MzYgMTAuMjcgMjAuMDYzNiAxMC42NkwyMC43NzM2IDExLjM3QzIxLjE2MzYgMTEuNzYgMjEuMTYzNiAxMi4zOSAyMC43NzM2IDEyLjc4TDIwLjA2MzYgMTMuNDlMMTcuOTQzNiAxMS4zN1pNMTcuMjMzNiAxMi4wOEwxMS45MzM2IDE3LjM4VjE5LjVIMTQuMDUzNkwxOS4zNTM2IDE0LjJMMTcuMjMzNiAxMi4wOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditNote = createIcon('EditNote', [
  [
    'path',
    {
      d: 'M2.93359 8.5H13.9336V10.5H2.93359V8.5ZM2.93359 6.5H13.9336V4.5H2.93359V6.5ZM2.93359 14.5H9.93359V12.5H2.93359V14.5ZM17.9436 11.37L18.6536 10.66C19.0436 10.27 19.6736 10.27 20.0636 10.66L20.7736 11.37C21.1636 11.76 21.1636 12.39 20.7736 12.78L20.0636 13.49L17.9436 11.37ZM17.2336 12.08L11.9336 17.38V19.5H14.0536L19.3536 14.2L17.2336 12.08Z',
      key: '1b5xec',
    },
  ],
]);

export default EditNote;
